export const organisationInvoices: TableModule = {
    name: "organisationInvoices",
    route: "spa.organisations.invoices",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }, {
        param: "mode",
        prop: "singleOrganisation"
    }],
    columns: [
        {
            name: "number",
            mobile: true,
        },
        {
            name: "status",
            breakpoint: "true"
        },
    ],
    filters: [],
    quickFilters: [],
    tools: []
}